import React, { useEffect, useState } from "react";
import { Tabs, Image } from "antd";
import { stationApi } from "../../../../../api/newApi";
import StationProcess from "../../../../../components/StationProcess";
import FlowUnitProcess from "../../../../../components/flowUnitProcess";
import ErrorImg from "./error.png";
import "./index.scss";

export default ({ stationId }) => {
  const [previewProcessData, setPreviewProcessData] = useState({});
  const [defaultActiveKey, setDefaultActiveKey] = useState("1");
  const [labelList, setLabelList] = useState([]);
  let timer = null;
  const step = 1000 * 30;

  useEffect(() => {
    if (stationId) {
      getUnitList();
    }
  }, [stationId]);

  useEffect(() => {
    if (stationId) {
      if (defaultActiveKey == "1") {
        getData();
      } else {
        findUnitFlow();
      }
      setData();
    }
    return () => {
      timer && clearInterval(timer);
    };
  }, [stationId, defaultActiveKey]);

  const setData = () => {
    timer && clearInterval(timer);
    if (defaultActiveKey == "1") {
      timer = setInterval(getData, step);
    } else {
      timer = setInterval(findUnitFlow, step);
    }
  };

  const getData = async () => {
    // 获取工艺流程
    const res = await stationApi.findFlowByStationId(stationId);
    if (res.status == "0") {
      const params = {
        stationId,
        name: `工艺流程`,
        ...res.data,
      };
      setPreviewProcessData(params);
    } else {
      setPreviewProcessData({
        stationId,
        name: `工艺流程`,
        canvasWidth: 0,
        canvasHeight: 0,
        iotGatewayNum: 0,
        processFlowUnitDTOList: [],
        processFlowDeviceDiyDTOList: [],
        canvasBg: "",
      });
    }
  };

  const getUnitList = () => {
    stationApi.selectHaveFlowUnitList(stationId).then((res) => {
      if (res.status !== "0") return;
      if (res.data && res.data.length > 0) {
        const arr = res.data.map((item) => {
          return {
            label: (
              <div className="tab-label" title={item.processunitName}>
                <Image
                  width={100}
                  src={item.canvasBg}
                  preview={false}
                  fallback={ErrorImg}
                />
                <p>{item.processunitName}</p>
              </div>
            ),
            key: item.processunitId,
            children: "",
          };
        });
        setLabelList(arr);
      }
    });
  };

  const findUnitFlow = () => {
    stationApi.findUnitFlow(stationId, defaultActiveKey).then((res) => {
      if (res.status !== "0") return;
      const find = labelList.find((item) => item.key === defaultActiveKey);
      find.children = (
        <div
          style={{
            height: `calc(100vh - 48px)`,
          }}
        >
          <FlowUnitProcess data={res.data} />
        </div>
      );
      setLabelList([...labelList]);
    });
  };

  return (
    <div className="factory-shebei">
      <Tabs
        style={{
          height: "100%",
        }}
        tabPosition="left"
        defaultActiveKey={defaultActiveKey}
        onChange={(key) => setDefaultActiveKey(key)}
        items={[
          {
            label: (
              <div className="tab-label">
                <Image
                  fallback={ErrorImg}
                  width={100}
                  preview={false}
                  src={previewProcessData.canvasBg}
                />
                <p>工艺总览图</p>
              </div>
            ),
            key: "1",
            children: (
              <div
                style={{
                  height: `calc(100vh - 48px)`,
                }}
              >
                <StationProcess
                  previewProcessData={previewProcessData}
                  dataShow={true}
                />
              </div>
            ),
          },
          ...labelList,
        ]}
      />
    </div>
  );
};
